export default __webpack_public_path__ + "static/media/Discover.e885a0ce.svg";